import { Controller } from "@hotwired/stimulus"

// Lightbox for the gallery manager: one Dialog component is rendered per page
// and each thumbnail fills it, rather than rendering a dialog per image.
//
//   <div data-controller="gallery-preview" data-gallery-preview-dialog-value="gallery-preview">
//     <button data-action="gallery-preview#open"
//             data-preview-src="…" data-preview-title="…" data-preview-href="…">…</button>
//     … <%= render Dialog.new(id: "gallery-preview") … %> …
//   </div>
export default class extends Controller {
    static targets = ["image", "title", "link"]
    static values = { dialog: String }

    open(event) {
        const trigger = event.currentTarget
        const { previewSrc, previewTitle, previewHref } = trigger.dataset

        if (this.hasImageTarget) {
            this.imageTarget.src = previewSrc
            this.imageTarget.alt = previewTitle ?? ""
        }
        if (this.hasTitleTarget) this.titleTarget.textContent = previewTitle ?? ""
        if (this.hasLinkTarget) this.linkTarget.href = previewHref ?? previewSrc

        document.getElementById(this.dialogValue)?.showModal()
    }
}
